export default {
  bankOptions (state) {
    if (!state.paymentList || state.paymentList.length === 0) return []
    return state.paymentList
      .filter(p => p.is_active !== false)
      .map(p => ({
        bank_id: p.code || p.bank_id || p.name,
        bank_fullname: p.name || p.bank_fullname
      }))
  },
  navItems (state) {
    if (!state.paymentList || state.paymentList.length === 0) {
      return []
    }
    
    const items = state.paymentList
      .filter(p => {
        // Filter only active items
        if (p.is_active === false) return false
        // Check for url_path or url
        const hasUrl = p.url_path || p.url
        // Check for name
        const hasName = p.name
        return hasUrl && hasName
      })
      .sort((a, b) => {
        // Sort by sort_order if available
        if (a.sort_order !== undefined && b.sort_order !== undefined) {
          return a.sort_order - b.sort_order
        }
        return 0
      })
      .map(p => {
        // Map API response to menu format
        const url = p.url_path || p.url
        const name = p.name
        const slug = p.code || p.slug || name.toLowerCase()
        
        return {
          url,
          name: name.includes('รายการฝาก') ? name : `รายการฝาก ${name}`,
          slug,
          icon: p.icon
        }
      })
    
    return items
  },
  filterItems (state) {
    if (!state.paymentList || state.paymentList.length === 0) return []
    return state.paymentList
      .filter(p => p.is_active !== false && p.name && p.sentname)
      .sort((a, b) => {
        if (a.sort_order !== undefined && b.sort_order !== undefined) {
          return a.sort_order - b.sort_order
        }
        return 0
      })
      .map((p, index) => ({
        // Use id or index+2 (since 0=ALL, 1=BANK)
        val: p.id || (index + 2),
        name: p.name,
        sentname: p.sentname || p.code || p.name.toLowerCase()
      }))
  },
  paymentMethods (state) {
    if (!state.paymentList || state.paymentList.length === 0) return []
    return state.paymentList
      .filter(p => p.is_active !== false && p.name && p.code)
      .sort((a, b) => {
        if (a.sort_order !== undefined && b.sort_order !== undefined) {
          return a.sort_order - b.sort_order
        }
        return 0
      })
      .map(p => ({
        label: p.name,
        type: p.code,
        settingKey: `withdraw_${p.code}`
      }))
  }
}
